import React from 'react';
import { MapPin, Phone, Clock, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { locations } from '../data/mock';

const Locations = () => {
  return (
    <section id="locations" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Convenient Care Across Georgia & Alabama
          </h2>
          <p className="text-xl text-gray-600">
            Six state-of-the-art locations to serve you
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {locations.map((location) => (
            <Card 
              key={location.id}
              className="group hover:shadow-2xl transition-all duration-300 border-gray-200 hover:border-[#E63946] bg-white"
            >
              <CardContent className="p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-gradient-to-br from-[#E63946] to-[#D32F3D] p-4 rounded-xl shadow-lg">
                    <MapPin className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-[#E63946] transition-colors">
                    {location.name}
                  </h3>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3 text-gray-600">
                    <MapPin className="h-5 w-5 text-[#20B2AA] flex-shrink-0 mt-0.5" />
                    <div>
                      <p>{location.address}</p>
                      <p>{location.city}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 text-gray-600">
                    <Phone className="h-5 w-5 text-[#20B2AA] flex-shrink-0" />
                    <a href={`tel:${location.phone}`} className="hover:text-[#E63946] transition-colors font-medium">
                      {location.phone}
                    </a>
                  </div>

                  <div className="flex items-center gap-3 text-gray-600">
                    <Clock className="h-5 w-5 text-[#20B2AA] flex-shrink-0" />
                    <span>{location.hours}</span>
                  </div>
                </div>

                <a
                  href={location.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button 
                    variant="outline" 
                    className="w-full border-2 border-[#E63946] text-[#E63946] hover:bg-[#E63946] hover:text-white font-semibold"
                  >
                    Get Directions
                    <ExternalLink className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
